import { useMutation } from '@tanstack/react-query';
import { sendExperimentationEmails } from '../services/experimentation';
import {
  showSuccessNotification,
  showErrorNotification,
} from '../services/common';

// eslint-disable-next-line import/prefer-default-export
export const useSendABTestEmails = ({ onSuccess }) =>
  useMutation(sendExperimentationEmails, {
    onSuccess: async () => {
      onSuccess && onSuccess();
      showSuccessNotification('Emails scheduled successfully');
    },
    onError: () => {
      showErrorNotification('Failed to schedule emails');
    },
  });
